<template>
  <div>
    <b-form @submit.stop.prevent="onSubmit()">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-5 col-xxl-5">
              <div class="row">
                <div class="col-lg-1 col-xxl-1 align-center">
                  <label for="" align-self="center">
                    {{
                      $t(
                        "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.FROM"
                      )
                    }}
                  </label>
                </div>
                <div class="col-lg-11 col-xxl-11">
                  <b-form-input
                    type="number"
                    min="0"
                    id="rcp-quantity-input"
                    name="rcp-quantity-input"
                    @wheel="$event.target.blur()"
                    @keypress="isNumber($event)"
                    v-model="min"
                    aria-describedby="name-live-feedback"
                  ></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-xxl-5">
              <div class="row">
                <div class="col-lg-1 col-xxl-1 align-center">
                  <label for="">{{
                    $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.TO")
                  }}</label>
                </div>
                <div class="col-lg-11 col-xxl-11">
                  <b-form-input
                    type="number"
                    min="0"
                    id="rcp-quantity-input"
                    name="rcp-quantity-input"
                    @wheel="$event.target.blur()"
                    @keypress="isNumber($event)"
                    v-model="max"
                    aria-describedby="name-live-feedback"
                  ></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-xxl-2 pb-3">
              <b-button
                block
                class="float-right"
                type="submit"
                variant="primary"
                @click.prevent="searchFilter()"
              >
                {{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.SEARCH")
                }}
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 mb-3">
        <h5 class="text-right">
          {{
            $t("PAGE.CUSTOMER_POINT.TABLE.TOTAL_LABEL").replace(
              "%s",
              tableCustomer.pagination.total
            )
          }}
        </h5>
      </div>

      <div class="table-content">
        <div class="table-responsive">
          <b-table
            id="my-table"
            head-variant="light"
            :fields="tableCustomer.fields"
            :items="tableCustomer.items"
            :per-page="tableCustomer.pagination.perPage"
            :current-page="tableCustomer.pagination.currentPage"
          >
            <template #cell(name)="data">
              <span v-if="data.item.first_name && data.item.last_name"
                >{{ data.item.first_name }} {{ data.item.last_name }}</span
              >
              <span v-else>-</span>
            </template>

            <template #cell(point)="data">
              <span v-if="data.item.total_point">{{
                data.item.total_point
              }}</span>
              <span v-else>-</span>
            </template>
          </b-table>

          <p class="text-center pt-3" v-if="tableCustomer.items.length < 1">
            {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
          </p>
        </div>

        <div class="row justify-content-between">
          <div div class="col-lg-3">
            <b-form-group
              id="name-input-group"
              :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
              label-for="name-input"
              label-cols="5"
              label-align-sm="left"
              label-size="lg"
            >
              <b-form-select
                v-model="tableCustomer.pagination.perPage"
                id="perPageSelect"
                size="sm"
                :options="tableCustomer.paginationOptions"
              ></b-form-select>
            </b-form-group>
          </div>

          <div div class="col-lg-6">
            <b-pagination
              v-model="tableCustomer.pagination.currentPage"
              :total-rows="tableCustomer.pagination.total"
              :per-page="tableCustomer.pagination.perPage"
              align="right"
            ></b-pagination>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="row" id="ccr-unapproved_reason_remark">
              <div class="col-lg-2">
                <label>
                  <h5>
                    {{ $t("PAGE.CUSTOMER_POINT.FORM.FIELDS.MESSAGE") }}
                  </h5>
                </label>
              </div>

              <div class="col-lg-10">
                <b-form-textarea
                  id="remark-input"
                  name="remark-input"
                  rows="3"
                  max-rows="6"
                  v-model="form.message"
                ></b-form-textarea>
              </div>
            </div>
          </div>
          <div class="col-lg-12 pt-4">
            <div class="row" id="ccr-unapproved_reason_remark">
              <div class="col-lg-2">
                <label>
                  <h5>
                    {{ $t("PAGE.CUSTOMER_POINT.FORM.FIELDS.IMAGE") }}
                  </h5>
                </label>
              </div>

              <div class="col-lg-10">
                <b-form-file
                  @change="handleMainImage"
                  ref="fileinput"
                  accept="image/*"
                  :placeholder="
                    this.$t('PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE')
                  "
                  v-model="form.image_file"
                  drop-placeholder="Drop file here..."
                ></b-form-file>
                <b-form-text id="input-live-help">
                  {{ $t("PAGE.CUSTOMER_POINT.FORM.HINT.MAX_FILE") }}
                </b-form-text>
                <div class="mt-2">
                  <div v-if="preview.image_path" class="row">
                    <div class="col-3">
                      <img
                        :src="preview.image_path"
                        alt="Main image"
                        class="image-preview"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action buttons-->
      <div class="mt-5">
        <b-row>
          <b-col sm="12">
            <b-button type="submit" variant="primary" class="float-right mr-3"
              >ส่งข้อความ</b-button
            >
          </b-col>
        </b-row>
      </div>
      <hr />
    </b-form>

    <div class="table-content">
      <div class="table-responsive">
        <b-table
          id="organizations-table"
          :striped="false"
          :items="tableCustomerCampaignReceiptReward.items"
          :fields="tableCustomerCampaignReceiptReward.fields"
          :sort-by.sync="pagination.orderBy"
          :sort-desc.sync="pagination.isDesc"
          :no-sort-reset="true"
          :no-local-sorting="true"
          :busy.sync="tableCustomerCampaignReceiptReward.isBusy"
          :loading="false"
          :borderless="false"
          head-variant="light"
          @sort-changed="sortChange"
        >
          <template #cell(id)="data">
            <div class="text-right">
              <span v-if="pagination.isDesc">{{
                tableCustomerCampaignReceiptReward.total -
                (pagination.perPage * (pagination.page - 1) + data.index)
              }}</span>
              <span v-if="!pagination.isDesc">
                {{
                  pagination.perPage * (pagination.page - 1) + data.index + 1
                }}
              </span>
            </div>
          </template>

          <template #cell(image_path)="data">
            <a
              v-if="data.item.image_path"
              :href="getImagePath(data.item.image_path)"
              target="_blank"
            >
              <img
                :src="getImagePath(data.item.image_path)"
                alt="Main image"
                class="img-thumbnail"
                width="120"
              />
            </a>
            <span v-if="!data.item.image_path"> - </span>
          </template>
        </b-table>

        <p
          class="text-center pt-3"
          v-if="tableCustomerCampaignReceiptReward.items.length < 1"
        >
          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
        </p>
      </div>

      <div class="row justify-content-between">
        <div div class="col-lg-3">
          <b-form-group
            id="name-input-group"
            :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
            label-for="name-input"
            label-cols="5"
            label-align-sm="left"
            label-size="lg"
          >
            <b-form-select
              v-model="pagination.perPage"
              id="perPageSelect"
              size="sm"
              :options="tableCustomerCampaignReceiptReward.paginationOptions"
              @change="fetchCampaignMessageData()"
            ></b-form-select>
          </b-form-group>
        </div>

        <div div class="col-lg-6">
          <b-pagination
            v-model="pagination.page"
            :total-rows="tableCustomerCampaignReceiptReward.total"
            :per-page="pagination.perPage"
            @input="fetchCampaignMessageData()"
            align="right"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FIND_CUSTOMER_CAMPAIGN_POINT } from "@/core/services/store/customer_campaign_point.module";
import {
  PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE,
  SET_PAGINATION,
  SET_IS_CLEAR_PAGINATION,
  CLEAR_PAGINATION
} from "@/core/services/store/customer_campaign_receipt_message.module";
import { CREATE_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE } from "@/core/services/store/customer_campaign_receipt_message.module";
import Swal from "sweetalert2";
import { Config } from "@/core/config/variable.config";

export default {
  name: "CustomerCampaignReceiptSendMessage",
  props: ["campaign_id"],
  data() {
    return {
      min: 0,
      max: 0,
      tableCustomer: {
        paginationOptions: [25, 50, 100, 200],
        pagination: {
          currentPage: 1,
          perPage: 25,
          total: 0
        },
        items: [],
        fields: [
          {
            key: "name",
            label: `${this.$t("PAGE.CUSTOMER_POINT.TABLE.FIELDS.CUSTOMER")}`,
            key_table: "name",
            sortable: false,
            isFilter: true
          },
          {
            key: "point",
            label: `${this.$t("PAGE.CUSTOMER_POINT.TABLE.FIELDS.POINT")}`,
            key_table: "point",
            tdClass: "text-right",
            thClass: "text-right",
            sortable: false,
            isFilter: false
          }
        ]
      },
      tableCustomerCampaignReceiptReward: {
        include: [],
        paginationOptions: [25, 50, 100, 200],
        total: 0,
        items: [],
        isBusy: false,
        select: [
          "customer_campaign_receipt_message.id",
          "customer_campaign_receipt_message.message",
          "customer_campaign_receipt_message.image_path",
          "customer_campaign_receipt_message.condition",
          "customer_campaign_receipt_message.number_send"
        ],
        fields: [
          {
            key: "id",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
            key_table: "id",
            sortable: true,
            isFilter: false,
            tdClass: "idField"
          },
          {
            key: "image_path",
            label: `${this.$t(
              "PAGE.CAMPAIGN_RECEIPT_MESSAGE.TABLE.FIELDS.IMAGE_PATH"
            )}`,
            tdClass: "text-center",
            key_table: "image_path",
            sortable: false,
            isFilter: true
          },
          {
            key: "message",
            label: `${this.$t(
              "PAGE.CAMPAIGN_RECEIPT_MESSAGE.TABLE.FIELDS.MESSAGE"
            )}`,
            key_table: "message",
            sortable: false,
            isFilter: true
          },
          {
            key: "condition",
            label: `${this.$t(
              "PAGE.CAMPAIGN_RECEIPT_MESSAGE.TABLE.FIELDS.CONDITION"
            )}`,
            key_table: "condition",
            sortable: false,
            isFilter: true
          },
          {
            key: "number_send",
            label: `${this.$t(
              "PAGE.CAMPAIGN_RECEIPT_MESSAGE.TABLE.FIELDS.NUMBER_SEND"
            )}`,
            key_table: "number_send",
            tdClass: "text-right",
            thClass: "text-right",
            sortable: false,
            isFilter: false
          }
        ]
      },
      preview: {
        image_path: null
      },
      form: {
        customer: [],
        message: null,
        image_path: null
      }
    };
  },
  mounted() {
    if (this.isClearPagination) {
      this.$store.commit(CLEAR_PAGINATION);
    }

    this.isClearPagination = true;
    this.fetchCampaignMessageData();
  },
  computed: {
    isClearPagination: {
      get() {
        return this.$store.state.customer_campaign_receipt_message
          .isClearPagination;
      },
      set(value) {
        this.$store.commit(SET_IS_CLEAR_PAGINATION, {
          isClearPagination: value
        });
      }
    },
    pagination: {
      get() {
        return this.$store.state.customer_campaign_receipt_message.pagination;
      },
      set(value) {
        this.$store.commit(SET_PAGINATION, { pagination: value });
      }
    }
  },
  methods: {
    getImagePath(image) {
      return `${Config.ADMIN_IMAGE_URL}/${image}`;
    },
    isNumber(event) {
      if (
        !(
          event.key === "Enter" ||
          (Number(event.key) >= 0 && Number(event.key) <= 9)
        )
      ) {
        return event.preventDefault();
      }
    },
    handleMainImage(e) {
      const selectImage = e.target.files[0];

      if (selectImage != undefined) {
        this.encodeBase64(selectImage);
      } else {
        this.setDefaultImage();
      }
    },
    setDefaultImage() {
      this.preview.image_path = null;
    },
    encodeBase64(file) {
      if (file.size > 1000000) {
        Swal.fire({
          icon: "error",
          text: `กรุณาเลือกรูปขนาดไม่เกิน 1 MB`,
          confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
        });
        this.$refs.fileinput.reset();
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.image_path = e.target.result;
          this.preview.image_path = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    getParams() {
      return {
        page: this.pagination.page.toString(),
        perPage: this.pagination.perPage.toString(),
        orderBy: "created_at",
        isDesc: this.pagination.isDesc.toString(),
        filter: this.pagination.filter.toString(),
        filterBy: `${this.tableCustomerCampaignReceiptReward.fields
          .map((item) => {
            if (item.isFilter) return item.key;
          })
          .filter((item) => !!item)}`,
        select: `${this.tableCustomerCampaignReceiptReward.select}`,
        include: `${this.tableCustomerCampaignReceiptReward.include}`,
        campaign_id: this.campaign_id
      };
    },
    fetchCampaignMessageData() {
      this.$store
        .dispatch(PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE, {
          params: this.getParams()
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.tableCustomerCampaignReceiptReward.items = data.data.data;
            this.tableCustomerCampaignReceiptReward.total = data.data.total;
            if (
              this.tableCustomerCampaignReceiptReward.total > 0 &&
              this.tableCustomerCampaignReceiptReward.items.length < 1
            ) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    sortChange(event) {
      this.pagination.isDesc = event.sortDesc;
      this.pagination.orderBy = event.sortBy;
      this.fetchCampaignMessageData();
    },
    fetchData() {
      this.$store
        .dispatch(FIND_CUSTOMER_CAMPAIGN_POINT, {
          min: this.min,
          max: this.max,
          campaign_id: this.campaign_id
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.tableCustomer.items = data.data;
            this.tableCustomer.pagination.total = data.data.length;
            this.form.customer = [];

            for (const customer of data.data) {
              this.form.customer.push(customer.customer_id);
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    searchFilter() {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.fetchData();
          this.tableCustomer.pagination.currentPage = 1;
          Swal.close();
        }
      });
    },
    addData(body) {
      this.$store
        .dispatch(CREATE_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE, body)
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            Swal.fire({
              icon: "success",
              text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
            this.form.message = null;
            this.form.image_path = null;
            this.preview.image_path = null;
            this.fetchCampaignMessageData();
            this.$refs.fileinput.reset();
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    async onSubmit() {
      this.form.condition = `เงื่อนไขคะแนน ${this.min} ถึง ${this.max}`;
      this.form.campaign_id = this.campaign_id;
      if (this.form.message == null && this.form.image_path == null) {
        Swal.fire({
          icon: "error",
          text: `กรุณาเลือกรูปหรือกรอกข้อความด้วย`,
          confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
        });
      } else {
        this.addData(this.form);
      }
    }
  }
};
</script>

<style scoped>
.align-center {
  display: flex;
  align-items: center;
}
.align-center label {
  margin: 0;
}
</style>
